<footer class="footer">
    <div class="container-fluid">
        <div class="copyright">
            &copy;
            {{test | date: 'yyyy'}}, Developed by
            <a href="https://www.bigdomino.co.za" target="_blank">Big Domino Marketing</a>
        </div>
    </div>
</footer>